var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"estatisticas"},[_c('div',{staticClass:"stat-icon"},[_c('v-icon',{attrs:{"color":_vm.cor}},[_vm._v(_vm._s(_vm.icon))])],1),_c('div',{staticClass:"stat-info"},[_c('span',{staticClass:"stat-title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"stat-value"},[_vm._v(_vm._s(_vm.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }